import {
  styled,
  Typography,
  Box,
  css,
  OutlinedInput,
  Button,
  Stack,
  InputLabel as InputLabelMUI,
} from "@mui/material";
import { customColors } from "models/customColors";
import { Link } from "react-router-dom";

export const globalStyles = css`
  @font-face {
    font-family: "Inter";
    font-weight: 400;
    src: url(/fonts/Inter-Regular.ttf) format("truetype");
  }

  @font-face {
    font-family: "Inter Medium";
    font-weight: 500;
    src: url(/fonts/Inter-Medium.ttf) format("truetype");
  }

  @font-face {
    font-family: "Inter Semi Bold";
    font-weight: 600;
    src: url(/fonts/Inter-SemiBold.ttf) format("truetype");
  }

  @font-face {
    font-family: "Inter Bold";
    font-weight: 700;
    src: url(/fonts/Inter-Bold.ttf) format("truetype");
  }

  body {
    margin: 0;
    font-family: Inter, sans-serif;
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-y: hidden;
  }

  a {
    color: ${customColors.mainColor};
  }
`;

export const AuthTitle = styled(Box)`
  color: ${customColors.mainColor};
  font-size: 18px;
  font-family: "Inter Semi Bold";
  font-weight: 600;
  word-wrap: break-word;
  text-align: center;
`;

export const AuthLink = styled(Link)`
  font-family: "Inter Medium";
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0em;
  color: ${customColors.mainColor};
  text-decoration: none;
`;

export const AuthButtonLink = styled(Box)`
  font-family: "Inter Medium";
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0em;
  color: ${customColors.mainColor};
  text-decoration: none;
  cursor: pointer;
`;

export const AuthContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
  min-width: 100dvw;
  min-height: 100dvh;
  gap: 1rem;
`;

export const AuthFormContent = styled(Stack)`
  padding: 40px 50px;
  width: 50vw;
  min-width: 340px;
  max-width: 550px;
  background-color: ${customColors.white};
  border-radius: 13px;
  gap: 1rem;

  @media (max-width: 480px) {
    padding: 10px 20px;
  }
`;

export const SubmitButton = styled(Button)`
  text-transform: none;
  font-family: "Inter Semi Bold";
  background-color: ${customColors.mainColor};
`;

export const InputLabel = styled(InputLabelMUI)`
  font-family: Inter;
`;

export const Input = styled(OutlinedInput)`
  align-self: stretch;
  font-family: Inter;
  background-color: ${customColors.lightGray};
`;

export const Error = styled(Box)`
  color: ${customColors.error};
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  word-wrap: break-word;
`;

export const Header1 = styled(Box)`
  font-family: "Inter Bold", sans-serif;
  font-size: 36px;
`;

export const Header2 = styled(Box)`
  font-family: "Inter Medium", sans-serif;
  font-size: 36px;
`;

export const Header3 = styled(Box)`
  margin: 20px 5px 20px 15px;
  font-family: "Inter Semi Bold", sans-serif;
  letter-spacing: 0.025rem;
  font-size: 22px;
`;

export const Title = styled(Box)`
  font-family: "Inter Medium", sans-serif;
`;

export const SubHeading = styled(Typography)`
  font-family: "Inter", sans-serif;
  font-size: 19px;
`;

export const Bold = styled(Typography)`
  font-family: "Inter Bold", sans-serif;
  font-size: 18px;
`;

export const GrayButton = styled(Button)`
  padding: 4px 20px;

  font-family: Inter;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: center;

  color: ${customColors.grayText};
  background-color: ${customColors.lightGray};
  text-transform: none;

  border-radius: 8px;

  @media (max-width: 640px) {
    font-size: 15px;
  }
`;

export const BlueButton = styled(GrayButton)`
  color: ${customColors.white};
  background-color: ${customColors.mainColor};

  &:hover {
    color: ${customColors.mainColor};
    background-color: ${customColors.selector};
  }
`;

export const InverseBlueButton = styled(GrayButton)`
  background-color: ${customColors.white};
  color: ${customColors.mainColor};

  &:hover {
    background-color: ${customColors.mainColor};
    color: ${customColors.selector};
  }
`;

export const InfoText = styled(Box)`
  padding: 0 0 10px 0;
  font-family: Inter;
  font-size: 17px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;

  color: ${customColors.grayText};
`;

export const Status = styled(Stack)`
  margin: 0 20px 0 0;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
`;

export const scrollStyle = css`
  &::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${customColors.grayText};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const StepIndicator = styled(Box)`
  width: 85px;
  height: 5px;
  border-radius: 15px;
  background: ${customColors.lightGrayText};

  @media screen and (orientation: portrait) and (max-device-width: 1024px) {
    width: 40px;
  }
`;

export const StepIndicatorActive = styled(StepIndicator)`
  background-color: ${customColors.mainColor};
`;
